export default __webpack_public_path__ + "35dbacd736781608964ae37a3b390b48.svg";